import * as types from './project-report.types';
import * as constants from './project-report.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeProjectReport = generateStoreResourceAction<types.IProjectReport>(constants.STORE_PROJECT_REPORT);
export const clearProjectReport = generateClearResourceAction(constants.CLEAR_PROJECT_REPORT);
